import { Col, Row, Select, Form, Switch } from "antd";
import { useTranslation } from "react-i18next";
import { settingsType } from "./settingsType";
type prop = {
  settings: settingsType | undefined;
  formatedCurrency: {}[] | undefined;
  loadingCurrency: boolean;
};
const Billing = ({ settings, formatedCurrency, loadingCurrency }: prop) => {
  const [t] = useTranslation("common");
  return (
    <>
      <Row>
        <Col span={6}>
          <Form.Item name="currency" label={`${t("main-currency")}`}>
            <Select
              data-testid="currency"
              placeholder={t("select-currency")}
              loading={loadingCurrency}
              options={formatedCurrency}
              showSearch={true}
              optionFilterProp="label"
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          <Form.Item name="currency" label={`${t("secondary-currency")}`}>
            <Select
              data-testid="currency"
              placeholder={t("select-currency")}
              loading={loadingCurrency}
              options={formatedCurrency}
              showSearch={true}
              optionFilterProp="label"
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        {/* <Col style={{ color: "black" }}>
          {t("set-exchange-rate-automatically")}
        </Col> */}
        <Col>
          {t("set-exchange-rate-automatically")}
          <br /> 
          <Switch />
        </Col>
      </Row>
    </>
  );
};

export default Billing;
